import { Grid } from '@material-ui/core';
import _ from 'lodash';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import QCXFinalFormDialog from '../../shared-components/dialog/QCXFinalFormDialog';
import QCXFinalDatePickerField from '../../shared-components/final-date-picker-field/QCXFinalDatePickerField';
import { CLOSED_STATUS, isOpenStatus } from '../../utils/hooks/form/dialog/formDialogUtils';

export default function QCXAlterarVencimentoDialogForm({
  handleOnSubmit,
  handleFormStatus,
  formDialogStatus,
  initialValues,
}) {
  const { t } = useTranslation();

  const isFormDialogOpen = useMemo(() => isOpenStatus(formDialogStatus), [formDialogStatus]);

  const handleCloseFormDialog = useCallback(() => {
    handleFormStatus(CLOSED_STATUS);
    _.debounce(() => {}, 200)();
  }, [handleFormStatus]);

  return (
    <QCXFinalFormDialog
      key="form-dialog-alterar-vencimento-conta-pagar"
      id="form-dialog-alterar-vencimento-conta-pagar"
      title="Alterar Data de Vencimento"
      dialogActionsProps={{
        button: {
          submit: {
            description: 'Alterar',
            size: 'small',
            color: 'secondary',
          },
          cancel: {
            description: t('com.muralis.qcx.acoes.cancelar'),
            size: 'small',
          },
        },
      }}
      open={isFormDialogOpen}
      initialValues={initialValues}
      onSubmit={handleOnSubmit}
      onClose={handleCloseFormDialog}
    >
      {() => (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <QCXFinalDatePickerField name="dataVencimento" label="Nova Data de Vencimento" required />
          </Grid>
        </Grid>
      )}
    </QCXFinalFormDialog>
  );
}
